/*
 * Utils系の置き場所
 * 適時ファイル分割などしよう！
 */

import * as dateFormatUtil from './dateFormatter';
import * as objectSnakelizerUtil from './objectSnakelizer';
import * as localeHandlerUtil from './localeHandler';

export const dateFormatter = dateFormatUtil;
export const objectSnakelizer = objectSnakelizerUtil;
export const localeHandler = localeHandlerUtil;

/**
 * Generate Random & Unique string from specified string
 */
export const getUniqueStr = () => {
  return (
    new Date().getTime().toString(16) +
    '_' +
    Math.random()
      .toString(36)
      .substr(2, 9)
  );
};

/**
 * Convert Byte(int) to appropriate unit number + extension
 * - ex: 400000 -> `390.63 B`
 * @param integer size
 */
export const convertByteSize = size => {
  const extentions = [' B', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB'];
  let ext = extentions.shift();
  if (typeof size !== 'number') {
    return false;
  }
  for (let extention of extentions) {
    if (size >= 1024) {
      size = size / 1024;
      ext = extention;
    }
  }
  return round(size, 2) + ext;
};

/**
 * 小数点のroundを行う
 * @param integer number 対象となる数値
 * @param integer precision 小数点何位まで丸めるか
 */
export const round = (number, precision) => {
  const shift = (number, precision, reverseShift) => {
    if (reverseShift) {
      precision = -precision;
    }
    const numArray = ('' + number).split('e');
    return +(
      numArray[0] +
      'e' +
      (numArray[1] ? +numArray[1] + precision : precision)
    );
  };
  return shift(Math.round(shift(number, precision, false)), precision, true);
};
